import React from 'react';
import eliteSsLeft1New from '../../assests/images/elite-ss-left-1-new.jpg';
import eliteSsLeft4New from '../../assests/images/elite-ss-left-4-new.png';
import eliteSsLeft5New from '../../assests/images/elite-ss-left-5-new.png';
import eliteSsLeft6New from '../../assests/images/elite-ss-left-6-new.png';
import eliteSsLeft7New from '../../assests/images/elite-ss-left-7-new.png';
import eliteSsLeft3New from '../../assests/images/elite-ss-left-3-new.png';
import eliteSsLeft3 from '../../assests/images/elite-ss-left-3.png';
import eliteSsLeft2 from '../../assests/images/elite-ss-left-2.png';
import eliteSsLeft1 from '../../assests/images/elite-ss-left-1.png';
import eliteSsLeft4 from '../../assests/images/elite-ss-left-4.png';
import eliteSsLeft5 from '../../assests/images/elite-ss-left-5.png';
import eliteSsLeft6 from '../../assests/images/elite-ss-left-6.png';

function SuccessStories() {
    // Success stories data array
    const successStories = [
        {
            id: 1,
            image: eliteSsLeft1New,
            names: 'Priya and Chetan',
            shortDescription: "Priya and Chetan's Magical Match. We are delighted to celebrate the union of Priya and Chetan, who found their perfect match through Kalyana Sapthapadhi Matrimony.",
            modalTarget: 'sspopupone-new',
            altText: 'Kalyana Sapthapadhi success story left image 1 new'
        },
        {
            id: 2,
            image: eliteSsLeft4New,
            names: 'Neha and Bharat',
            shortDescription: "Neha and Bharat's Beautiful Union. We are thrilled to share the joyous news of Neha and Bharat's marriage, facilitated by Kalyana Sapthapadhi Matrimony!",
            modalTarget: 'sspopupfour-new',
            altText: 'Kalyana Sapthapadhi success story left image 4 new'
        },
        {
            id: 3,
            image: eliteSsLeft5New,
            names: 'Roshini and Santhosh',
            shortDescription: "Santhosh joined Kalyana Sapthapadhi services and was shown several good profiles. The Relationship Manager kept in touch with him and his folks, seeking constant feedback about what kind of a life partner he was looking for.",
            modalTarget: 'sspopupfive-new',
            altText: 'Kalyana Sapthapadhi Success Story Image'
        },
        {
            id: 4,
            image: eliteSsLeft6New,
            names: 'Sarat and Sriranjani',
            shortDescription: "Sarat Ram, a successful businessman from Bangalore, knew exactly what he was looking for in a partner – someone with a strong educational background, preferably from Bangalore, and who shared his desire for a lasting commitment.",
            modalTarget: 'sspopupsix-new',
            altText: 'Kalyana Sapthapadhi Success Story Image'
        },
        // {
        //     id: 5,
        //     image: eliteSsLeft7New,
        //     names: 'Saranya and Vishnu',
        //     shortDescription: "Finding someone who respected tradition and shared her family's values was important to Saranya. The Relationship Manager at Kalyana Sapthapadhi Services understood this and presented her with Vishnu Kumar's profile.",
        //     modalTarget: 'sspopupseven-new',
        //     altText: 'Kalyana Sapthapadhi Success Story Image'
        // },
        // {
        //     id: 6,
        //     image: eliteSsLeft3New,
        //     names: 'Vamsi Kotte and Vaidehi',
        //     shortDescription: "Vamsi and Vaidehi Tie the Knot through Kalyana Sapthapadhi Matrimony! In a beautiful union of love and tradition, Vamsi and Vaidehi embarked on their lifelong journey together through Kalyana Sapthapadhi Matrimony.",
        //     modalTarget: 'sspopupthree-new',
        //     altText: 'Kalyana Sapthapadhi success story left image 3 new'
        // },
        // {
        //     id: 7,
        //     image: eliteSsLeft3,
        //     names: 'Prasenjit and Samrajni',
        //     shortDescription: "Prasenjit, looking for a partner with similar values and goals, found himself connected with Samrajni through Kalyana Sapthapadhi Matrimony's matchmaking services.",
        //     modalTarget: 'sspopupthree',
        //     altText: 'Kalyana Sapthapadhi success story left image 3'
        // },
        // {
        //     id: 8,
        //     image: eliteSsLeft2,
        //     names: 'Nikita and Indrajit',
        //     shortDescription: "Nikita, a successful businesswoman from Kolkata, knew exactly what she was looking for in a partner – someone with a strong educational background, preferably from Kolkata, and who shared her desire for a lasting commitment.",
        //     modalTarget: 'sspopuptwo',
        //     altText: 'Kalyana Sapthapadhi success story left image 2'
        // },
        // {
        //     id: 9,
        //     image: eliteSsLeft1,
        //     names: 'Souvick and Tania',
        //     shortDescription: "Finding a partner who fit both Souvick's personal preferences and his family's values was a top priority. Thankfully, Tania's profile on Kalyana Sapthapadhi Matrimony seemed to tick all the boxes!",
        //     modalTarget: 'sspopupone',
        //     altText: 'Kalyana Sapthapadhi success story left image 1'
        // },
        // {
        //     id: 10,
        //     image: eliteSsLeft4,
        //     names: 'Siddharth and Parnarshee',
        //     shortDescription: "Siddharth's family, established in business, sought a bride who shared their background and was open to relocating to Kolkata. Kalyana Sapthapadhi Matrimony's Relationship Manager meticulously searched their database and discovered Parnarshee's profile, perfectly matching their requirements.",
        //     modalTarget: 'sspopupfour',
        //     altText: 'Kalyana Sapthapadhi success story left image 4'
        // },
        // {
        //     id: 11,
        //     image: eliteSsLeft5,
        //     names: 'Anurag and Anuradha',
        //     shortDescription: "Finding someone who respected tradition and shared her family's values was important to Anuradha. The Relationship Manager at Kalyana Sapthapadhi Matrimony understood this and presented her with Anurag's profile.",
        //     modalTarget: 'sspopupfive',
        //     altText: 'Kalyana Sapthapadhi Success Story Image'
        // },
        // {
        //     id: 12,
        //     image: eliteSsLeft6,
        //     names: 'Krishna and Soumaya',
        //     shortDescription: "Krishna joined Kalyana Sapthapadhi Matrimony hoping to find his ideal partner, someone who would complement his life and share his dreams. The Relationship Manager worked closely with Krishna and his family to understand their preferences and refine their search criteria.",
        //     modalTarget: 'sspopupsix',
        //     altText: 'Kalyana Sapthapadhi Success Story Image'
        // }
    ];

    // Group stories into slides (3 stories per slide)
    const slides = [];
    for (let i = 0; i < 3; i++) {
        const slide = [];
        for (let j = 0; j < 3; j++) {
            slide.push(successStories[(i * 3 + j) % successStories.length]);
        }
        slides.push(slide);
    }


    return (
        <section className="success-stories" style={{ background: '#f9f9f9', padding: '40px 0' }}>
            <div className="container-min container-max1 container-min-ss">
                <div className="row">
                    <h2 className="col-md-12 col-12 pt-3 pb-3 text-center font-great-vibes xs-pb0">
                        Kalyana Sapthapadhi Success Stories
                    </h2>
                </div>
                <div className="row pb-3 xs-pt0 xs-mt0 xs-pb5">
                    <div className="col-md-10 col-12 mx-auto text-center xs-mt15">
                        <div className="pb-3 ss-title-text-new">
                            Thousands of Kalyana Sapthapadhi members have found their life partner through Kalyana Sapthapadhi matrimony.
                        </div>
                    </div>
                </div>
                {/* Bootstrap Carousel */}
                <div id="successCarousel" className="carousel slide" data-bs-ride="carousel" data-bs-interval="4000">
                    <div className="carousel-inner">
                        {slides.map((slide, index) => (
                            <div key={index} className={`carousel-item ${index === 0 ? 'active' : ''}`}>
                                <div className="row">
                                    {slide.map((story) => (
                                        <div key={story.id} className="col-md-4 text-left ss-new-card-width">
                                            <div className="ss-card-equal-height d-flex flex-column align-items-center justify-content-start text-center">
                                                <img
                                                    src={story.image}
                                                    alt={story.altText}
                                                    style={{ height: "250px", width: "100%", objectFit: "cover" }}
                                                />
                                                <h3 className="ss-card-profile-text mt-3">{story.names}</h3>
                                                <div className="story-description flex-grow-1" style={{
                                                    textAlign: "left",
                                                    marginTop: '10px',
                                                }}>
                                                    {story.shortDescription}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    {/* Custom-colored carousel arrows */}
                    <button className="carousel-control-prev" type="button" data-bs-target="#successCarousel" data-bs-slide="prev"
                        style={{
                            width: '60px',
                            height: '60px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            backgroundColor: '#000000',
                            border: 'none',
                            borderRadius: '50%',
                        }}
                    >
                        <i className="bi bi-chevron-left" style={{ fontSize: '30px', color: '#ffffffff' }}></i>
                    </button>
                    <button className="carousel-control-next" type="button" data-bs-target="#successCarousel" data-bs-slide="next"
                        style={{
                            width: '60px',
                            height: '60px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            backgroundColor: '#000000',
                            border: 'none',
                            borderRadius: '50%',
                        }}
                    >
                        <i className="bi bi-chevron-right" style={{ fontSize: '30px', color: '#ffffffff' }}></i>
                    </button>
                </div>
            </div>
        </section>
    );
}

export default SuccessStories;
